export const getProgress = (severity: string, tempo: number, sla: number) => {
  let total: number;
  let sla1: number;

  switch (severity) {
    case 'URGENTE':
      // 180 minutos ou 3 horas
      sla1 = 2400; // 40 minutos
      total = 10800; // 180 minutos
      break;

    case 'ALTA':
      // 300 minutos ou 5 horas
      sla1 = 5400; // 90 minutos
      total = 18000; // 300 minutos

      break;

    case 'MEDIA':
      //360 minutos ou 6 horas
      sla1 = 10800; // 180 minutos
      total = 21600; // 360 minutos
      break;

    case 'BAIXA':
      // 480 minutos ou 8 horas
      sla1 = 18000; // 300 minutos
      total = 28800; // 480 minutos
      break;

    default:
      sla1 = 0;
      total = 0;
      break;
  }

  if (sla === 1) {
    return tempo > 0 ? ((tempo * 100) / sla1).toFixed(0) : 0;
  }
  return tempo > 0 ? ((tempo * 100) / total).toFixed(0) : 0;
};
